import axios from 'axios';

export const baseUrl = process.env.REACT_APP_BASE_URL

const instance = axios.create({
  baseURL: baseUrl + '/api'
});

instance.interceptors.request.use((request) => {

  let token = JSON.parse(localStorage.getItem('token'))

  request.headers = {
    'Accept': "application/json, text/plain, */*",
    'Authorization': `Bearer ${token}`,
  }
  return request
});

instance.interceptors.response.use((response) => {
  if (response) {
    return response
  }
}, (error) =>
  Promise.reject(
    error
  )
);

export default instance;